import { env } from '../methods/env'

const SystemMixin = {
    data () {
        return {
            system: {
                isIOS: false,
            },
            env
        }
    },
    methods: {
        updateSystemInfo () {
            const {
                userAgent
            } = navigator
            this.system.isIOS = /(iPhone|Apple|iOS)/i.test(userAgent)
        }
    },
    beforeCreated () {
        this.updateSystemInfo()
    }
}

export default SystemMixin



// WEBPACK FOOTER //
// ./src/mixins/system.js